import type { FC, PropsWithChildren } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';
import isBoolean from 'lodash-es/isBoolean';
import type { ThemeTypings } from '@chakra-ui/system';

interface ConditionalRenderProps {
    visibility: Partial<Record<ThemeTypings['breakpoints'], boolean>> | boolean;
}

export const ConditionalRender: FC<PropsWithChildren<ConditionalRenderProps>> = ({
    visibility,
    children,
}) => {
    const isVisible = useBreakpointValue(isBoolean(visibility) ? { base: visibility } : visibility);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return isVisible ? <>{children}</> : null;
};
